import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';

import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { LoaderEvent } from './../../shared/message.event';
import { FeedbackService } from './../feedback.service';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'app-feedback-reply',
    templateUrl: './feedback-reply.component.html',
    styleUrls: ['./feedback-reply.component.css'],
    providers: [LoaderEvent, FeedbackService],
    exportAs: 'feedbackReply'
})
export class FeedbackReplyComponent implements OnInit {
    private popUpMessage = '';
    @ViewChild('childModal') childModal: ModalDirective;
    @Input() message = '';
    @Input() popupTitle;
    @Input() cancleButton;
    @Output() notify = new EventEmitter<boolean>();
    @Output() notifyDelete = new EventEmitter<boolean>();
    @Input() deleteMessage;
    @Input() tempFacilityId;
    @Input() vendorId;
    private memberData = {};
    @Input() reply = {
        'subject': '',
        'content': ''
    }
    @Output() facilityid = new EventEmitter<string>();
    private validate = {
        'subject': '',
        'content': ''
    }
    private utilityFunctions = new UtilityFunctions();

    constructor(private loaderEvent: LoaderEvent, private feedbackService: FeedbackService, private appService: AppService) {
    }

    public showChildModal(item): void {
        try {
            this.memberData = item;
            this.validate.subject = '';
            this.validate.content = '';
            this.reply.subject = this.memberData['subActivity'];
            this.reply.content = '';
            this.childModal.config.backdrop = false;
            this.childModal.show();
        } catch (e) {
            console.log(e);
        }
    }

    public hideChildModal(): void {
        try {
            this.childModal.hide();
        } catch (e) {
            console.log(e);
        }
    }

    ngOnInit() {
    }
    /**
     * API call for reply to feedback
     * 
     * @param {any} popup 
     * 
     * @memberof FeedbackReplyComponent
     */
    onClickSend(popup) {
        try {
            this.reply.subject = (this.reply.subject + '').trim();
            this.reply.content = (this.reply.content + '').trim();
            if (this.validationOfReply('')) {
                let reply = {
                    'feedbackId': this.memberData['_id'],
                    'content': this.reply.content,
                    'vendorId': this.vendorId,
                    'userId': this.memberData['userId'],
                    'subject': this.reply.subject,
                    'activity': this.memberData['activity'],
                    'subActivity': this.memberData['subActivity']

                }
                this.loaderEvent.fire(false);
                this.feedbackService.feedbackResponse(reply).then((result: any) => {
                    if (result.status === 'SUCCESS') {
                    }
                    this.popUpMessage = result.message;
                    this.hideChildModal();
                    this.loaderEvent.fire(true);
                    popup.showChildModal();
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Hide popup
     * 
     * 
     * @memberof FeedbackReplyComponent
     */
    onClickCancel() {
        try {
            this.hideChildModal();
            this.notify.emit(false);
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Validate field which has to reply
     * 
     * @param {any} para 
     * @returns 
     * 
     * @memberof FeedbackReplyComponent
     */
    validationOfReply(para) {
        let flag = true;
        switch (para) {
            case 'subject':
                if (!this.reply.subject) {
                    this.validate.subject = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                } else {
                    this.validate.subject = '';
                }
                break;
            case 'content':
                if (!this.reply.content) {
                    this.validate.content = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                } else {
                    this.validate.content = '';
                }
                break;
            default:
                if (!this.reply.subject) {
                    this.validate.subject = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                }
                if (!this.reply.content) {
                    this.validate.content = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;
                }
                break;
        }
        return flag;
    }
}



// WEBPACK FOOTER //
// ./src/app/feedback/feedback-reply/feedback-reply.component.ts